// Must match the #Slowed width in css/window.css. The native popup document
// is shrink-to-fit, so it has to be pinned to this: the sheet chip rows are
// horizontal scroll containers, and their unclipped intrinsic width would
// otherwise propagate up and make Chrome widen the popup window (to its
// 800px cap) the first time a sheet opens — which it never undoes.
export const POPUP_WIDTH_PX = 525;
export const SHARE_COPY_RESET_MS = 3000;
// How long a mood's name replaces the wordmark after it is applied. Matches
// the skin-logo.css announcement animation.
export const MOOD_ANNOUNCEMENT_MS = 2200;
export const HIDDEN_VIDEO_FX_NAMES = ["Pu-241", "Ghost", "Vintage", "WMP"];
// Parked from the picker until their loops ship. Removing a key here brings
// the tile back. Moods can still set the underlying modes.
export const HIDDEN_AUDIO_MODE_KEYS = ["hotelLounge", "cocktailBar"];

// Retired from the picker. www.slowed.app/data.json may still list these until
// the site catches up, and chrome.storage can hold an older cached list.
const RETIRED_VIDEO_FX_VALUES = new Set(["slowed", "wmp"]);

export function normalizeVideoFxs(videoFxs) {
  if (!Array.isArray(videoFxs)) return [];
  return videoFxs.filter((fx) => !RETIRED_VIDEO_FX_VALUES.has(fx?.value));
}
